type KebabToScreamingSnakeCase<S extends string> =
    S extends `${infer Head}-${infer Tail}`
        ? `${Uppercase<Head>}_${KebabToScreamingSnakeCase<Tail>}`
        : Uppercase<S>;

/**
 * Convert a kebab-case string to SCREAMING_SNAKE_CASE.
 *
 * Replaces all `-` characters with `_` and uppercases the result. The
 * `KebabToScreamingSnakeCase` type maps a string literal type at compile-time
 * to the corresponding screaming snake case literal.
 *
 * @example
 * kebabToScreamingSnakeCase("some-event-name") // => "SOME_EVENT_NAME"
 *
 * @param str - Input string in kebab-case (e.g. `"some-event-name"`).
 * @returns The input converted to screaming snake case (e.g. `"SOME_EVENT_NAME"`).
 */
export function kebabToScreamingSnakeCase<S extends string>(
    str: S,
): KebabToScreamingSnakeCase<S> {
    return str.replace(/-/g, "_").toUpperCase() as KebabToScreamingSnakeCase<S>;
}
